
<template>
  <div class="property_wrap formedit">
    <div class="pro_top">单项选择</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-radio-group v-model="property.radio">
            <el-radio :label="1">性别</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提示语" v-if="property.radio==2">
          <el-input v-model="property.name2" maxlength="20" show-word-limit></el-input>
          </el-form-item>
        <el-form-item label="选项" v-if="property.radio==2">
          <div class="from_item" v-for="(item,idx) in property.list" :key="idx">
            <el-input v-model="item.label" maxlength="20" show-word-limit></el-input>
            <i class="el-icon-circle-plus-outline" @click="add()"></i>
            <i class="el-icon-remove-outline" v-if="property.list.length>2" @click="del(idx)"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
       form: {},
       list:[]
    };
  },
  created() {
     this.list= this.property.list
     
  },
  methods: {
    add(){
       var idx=this.property.list.length+1
       var idx1=idx.toString()
      this.property.list.push({label:"选项",disabled:false,value:idx1,checked:false})
    },
    del(e){
      this.property.list.splice(e,1)
    }
  }
};
</script>

 

 